import type { ReactElement, ReactNode } from 'react';

import { Knopf } from './Knopf';

/**
 * Bestätigung für kritische Aktionen (§20.3, §25.3).
 *
 * §20.3 verlangt Bestätigungsdialoge für kritische Aktionen und **zusätzlich** eine erneute
 * serverseitige Statusprüfung. Dieser Dialog leistet nur den ersten Teil; der Server prüft den
 * Zustand bei jeder Aktion ohnehin erneut.
 *
 * Bewusst als eingebettete Karte statt als natives `dialog`-Element: so bleibt der Zusammenhang
 * zur ausgelösten Aktion sichtbar, und es entsteht keine Fokusfalle auf schmalen Bildschirmen.
 */
export function BestaetigungsDialog({
  titel,
  beschreibung,
  bestaetigungstext,
  laeuft,
  gefahr,
  onBestaetigen,
  onAbbrechen,
}: {
  titel: string;
  beschreibung: ReactNode;
  bestaetigungstext: string;
  laeuft: boolean;
  /** Hebt unwiderrufliche Aktionen hervor, etwa Beenden oder Löschen. */
  gefahr?: boolean;
  onBestaetigen: () => void;
  onAbbrechen: () => void;
}): ReactElement {
  return (
    <div
      role="alertdialog"
      aria-labelledby="bestaetigung-titel"
      className={[
        'bg-flaeche flex flex-col gap-3 rounded-xl border p-4 shadow-sm',
        gefahr === true ? 'border-fehler/50' : 'border-rand',
      ].join(' ')}
    >
      <h3 id="bestaetigung-titel" className="text-base font-semibold">
        {titel}
      </h3>
      <div className="text-text-gedaempft text-sm">{beschreibung}</div>
      <div className="flex flex-wrap gap-2">
        <Knopf
          art={gefahr === true ? 'gefahr' : 'primaer'}
          onClick={onBestaetigen}
          disabled={laeuft}
        >
          {laeuft ? 'Wird ausgeführt …' : bestaetigungstext}
        </Knopf>
        <Knopf art="sekundaer" onClick={onAbbrechen} disabled={laeuft}>
          Abbrechen
        </Knopf>
      </div>
    </div>
  );
}
